'use strict'

/**
 * Object with all validations of the login form inputs.
 *
 * @author C Camilo Castellanos
 * @since 28/08/2018 5:33 PM
 * @version 1.0.0
 */
export default {
  referencia: {
    required: true,
    max: 30
  },
  tipoDocumentoId: {
    required: true
  },
  numeroDocumento: {
    required: true,
    max: 20,
    alpha_num: true
  }
}
